import * as firebase from 'firebase';
import 'firebase/firestore';


var firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();


const firestore = firebase.firestore();
const storage = firebase.storage()
export const auth = {user: null}
firebase.auth().onAuthStateChanged(user => {auth.user = user})

export { firebase, firestore as default, storage }

